import { render } from "./OpenTasks.vue?vue&type=template&id=27b33b76"
import script from "./OpenTasks.vue?vue&type=script&lang=js"
export * from "./OpenTasks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\vueproject\\test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__